import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    width: '100%',
    marginBottom: '10px',
  },

  inputRoot: {
    // color: COLORS.WHITE,
    fontSize: '1.5rem',
    '& > input:-webkit-autofill': {
      '-webkit-box-shadow': '0 0 0 30px #ffffff inset',
      // '-webkit-box-shadow': '0 0 0 30px #333333 inset',
      // color: 'white !important',
      // '-webkit-text-fill-color': 'white',
    },
  },
  inputUnderline: {
    '&:before': {
      borderBottom: `2px solid ${COLORS.GREY_DARK}`,
      // borderBottom: `2px solid ${COLORS.GREY}`,
    },
  },
  label: {
    fontWeight: 400,
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  labelFocused: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  labelShrink: {
    fontWeight: 600,
    fontSize: '1rem',
    color: COLORS.GREY_DARKER,
    textTransform: 'uppercase',
  },
  tooltip: {
    backgroundColor: COLORS.GREEN,
    color: COLORS.WHITE,
  },
  errorTextStyle: {
    position: 'absolute',
    bottom: '-1.25rem',
  },
});

export default styles;
